import { RouteConfig } from "vue-router";

export const routes: Array<RouteConfig> = [
	{
		path: "/url-shortener",
		name: "UrlShortener",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "url-shortener" */ "@/views/url-shortener/UrlShortener.vue"),
	},
];
